export default getYTicks;

/**
 * Construct the ticks for the vertical (y) axis.
 *
 * Because of the way ticks are generated by d3, we cannot guarantee a nicely
 * spaced range of ticks that includes the start and end of the domain.
 *
 * Due to that, we create a custom array of nicely spaced ticks, but only
 * when the start of the domain is below 0.
 *
 * Below 0, the d3 builtin tick generation method is used, because it is
 * a lot harder to create an array of nicely spaced ticks by hand.
 *
 * @param {function} y Linear scale with configured domain
 * @returns {array} array of ticks
 */
function getYTicks(y: any): any {
  const [tickStart, tickEnd] = [...y.domain()];

  if (tickStart < 0) {
    return y.ticks(4);
  } else {
    return [
      tickStart,
      tickStart + tickEnd / 3,
      (tickStart + tickEnd / 3) * 2,
      tickEnd,
    ];
  }
}
